import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from '../lecture-api'
import { PlayCount, IPlayCountHeatmap } from '../../models'
import { Injectable } from '@angular/core'

@Injectable()
export abstract class PlayCountApi {
  abstract apiPath(resourceId: number, historyId?)

  constructor(
    private api: LectureApiBase,
  ) { }

  index(resourceId: number, groupIds?: number[]): Observable<PlayCount[]> {
    return this.api.listWithObject(PlayCount, this.api.makeUrlWithParams(this.apiPath(resourceId), { groupIds }))
  }

  show(resourceId: number, userId: number): Observable<PlayCount> {
    return this.api.getWithObject(PlayCount, this.apiPath(resourceId, userId.toString()))
  }

  heatmap(resourceId: number, groupIds?: number[]): Observable<IPlayCountHeatmap> {
    return this.api.get(this.api.makeUrlWithParams(`${this.apiPath(resourceId)}heatmap`, { groupIds }))
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-count/base.ts